export function AnalyticsIcon(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 22" width="1em" height="1em" fill="currentcolor" {...props}>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Dashboard-Filled" transform="translate(-678.000000, -32.000000)" stroke="currentcolor" strokeWidth="1.5">
                    <g id="header" transform="translate(381.000000, 29.000000)">
                        <g id="templates-copy" transform="translate(296.000000, 2.000000)">
                            <g id="Group" transform="translate(2.000000, 2.000000)">
                                <path d="M17,7.225 L17,8.5 C17,12.5069 17,14.51035 15.75475,15.75475 C14.5112,17 12.5069,17 8.5,17 C4.4931,17 2.48965,17 1.2444,15.75475 C0,14.5112 0,12.5069 0,8.5 C0,4.4931 0,2.48965 1.2444,1.2444 C2.4905,0 4.4931,0 8.5,0 L9.775,0" id="Path" strokeLinecap="round" />
                                <path d="M4.25,10.2 L5.77745,8.3674 C6.38265,7.64065 6.68525,7.2777 7.08305,7.2777 C7.4817,7.2777 7.7843,7.64065 8.3895,8.3674 L8.6105,8.6326 C9.2157,9.35935 9.5183,9.7223 9.91695,9.7223 C10.3156,9.7223 10.61735,9.35935 11.22255,8.6326 L12.75,6.8" id="Path" strokeLinecap="round" />
                                <circle id="Oval" cx="14.45" cy="2.55" r="2.55" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
